import React from "react";
import { useState, Fragment } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { countries } from "country-data-list";
import * as service from "./service";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
// import CurrentPasswordModal from "../../../Components/Modals/CurrentPasswordModal";
import CancelSubscriptionModal from "../../../Components/Modals/CancelSubscriptionModal";
import PauseSubscriptionModal from "../../../Components/Modals/PauseSubscriptionModal";
import LogoutAllModal from "../../../Components/Modals/LogoutAllModal";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import Loading from "../../../Components/Loading/Loading";
import Translate from "../../../Components/Multilanguage/Translate";
import { delay } from "../../../utils/utils";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import { resumeSubscription } from "./service";
import { current } from "@reduxjs/toolkit";


const AccountSettings = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const selectedLanguage = useSelector((state) => state?.languageModal?.value?.selectedLanguage);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [accountDetails, setAccountDetails] = useState({});
  const [countryListOption, setCountryListOption] = useState([]);
  const [values, setValues] = useState({});
  // const [PasswordModal, setPasswordModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [cancelSubModal, setCancelSubModal] = useState(false);
  const [pauseSubModal, setPauseSubModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [profileWill, setProfileWill] = useState()
  const [loading, setLoading] = useState(true)
  const [changedValue, setChangedValue] = useState({ email_sms_consent: true });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentCountry, setCurrentCountry] = useState({})
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(true);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const theme = projectInfo?.projectConfig?.config?.THEME;
  useEffect(() => {
    window.scroll(0, 0);
    fetchAccountDetails();
    // setCountryListOption(
    //   countries?.all?.map((item, index) => {
    //     const { alpha2, name } = item;
    //     return (
    //       <option key={index} value={alpha2}>
    //         {name}
    //       </option>
    //     );
    //   })
    // );
  }, []);
  useEffect(() => {
    if (accountDetails) {
      setCountryListOption(
        countries?.all?.map((item, index) => {
          const { alpha2, name } = item;
          if (item?.alpha2 !== accountDetails?.country_code) {
            return (
              <option key={index} value={alpha2}>
                {name}
              </option>
            );
          } else {
            setCurrentCountry({ name, value: alpha2 })
          }
        })
      );
    }
  }, [accountDetails])

  const handleResume = async () => {
    setLoading(true);
    try {
      const response = await resumeSubscription(appInfo, accountDetails?.sub_id, accountDetails?.user_subscription_id);
      if (response?.status === 200) {
        toast.success(<Translate textKey={'subscription_resume'} />, {
          position: "bottom-center",
        });
        setPauseSubModal(false);
        fetchAccountDetails?.(true);
      } else {
        toast.error(response?.data?.message || "Failed to resume subscription.");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAccountDetails = async (isUpdate) => {
    setLoading(true)
    try {
      isUpdate && await delay(3000);
      const accountDetailsResponse = await service.getAccountDetails(appInfo);
      if (accountDetailsResponse?.status === 200) {
        const currentValues = {
          email: accountDetailsResponse?.data?.data?.user_email,
          firstName: accountDetailsResponse?.data?.data?.first_name,
          lastName: accountDetailsResponse?.data?.data?.last_name,
          phone: accountDetailsResponse?.data?.data?.phone,
          country: accountDetailsResponse?.data?.data?.country_code,
          address1: accountDetailsResponse?.data?.data?.address1,
          address2: accountDetailsResponse?.data?.data?.address2,
          city: accountDetailsResponse?.data?.data?.city,
          state: accountDetailsResponse?.data?.data?.state,
          postal_code: accountDetailsResponse?.data?.data?.postal_code,
          celebrity_source: accountDetailsResponse?.data?.data?.celebrity_source,
          favorite_celebrity: accountDetailsResponse?.data?.data?.favorite_celebrity,
          birthday: accountDetailsResponse?.data?.data?.birthday,
          instagram: accountDetailsResponse?.data?.data?.instagram,
          youtube: accountDetailsResponse?.data?.data?.youtube,
          facebook: accountDetailsResponse?.data?.data?.facebook,
          tiktok: accountDetailsResponse?.data?.data?.tiktok,
        }
        setValues({
          ...values,
          ...currentValues
        });
        setChangedValue({
          ...changedValue,
          ...currentValues,
          email_sms_consent: accountDetailsResponse?.data?.data?.email_sms_consent,
        });
        if (accountDetailsResponse?.data?.data?.email_sms_consent === true || accountDetailsResponse?.data?.data?.email_sms_consent === false) {
          setDisclaimerAccepted(accountDetailsResponse?.data?.data?.email_sms_consent);
          setChangedValue({
            ...changedValue,
            ...currentValues,
            email_sms_consent: accountDetailsResponse?.data?.data?.email_sms_consent,
          });
        } else {
          setDisclaimerAccepted(true);
          setChangedValue({
            ...changedValue,
            ...currentValues,
            email_sms_consent: true,
          });
        }
        setAccountDetails(accountDetailsResponse?.data?.data);
        if (isUpdate) {

          dispatch(
            getUserDetails({
              userDetails: accountDetailsResponse?.data?.data,
            })
          );
        }
        setLoading(false)
      }
    } catch (err) {

    }
  };
  const handleUpdate = (item) => {
    const { name, value } = item?.target;
    handleChange(name, value);
  };

  const handleChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
    setChangedValue({
      ...changedValue,
      [name]: value,
      ['countryName']: currentCountry?.name,
    })
  };

  const handleUpdateItem = (item) => {
    const { name, value } = item?.target;
    setValues({
      ...values,
      [name]: value,
    });
  }


  const validation = () => {
    let validationStatus = true;
    let errors = {};
    let nameRegex = /^[a-zA-Z ]{3,30}$/;
    const { firstName, lastName, country, phone } = values;

    if (!firstName) {
      errors.firstName = <Translate textKey={'first_name_required'} />
      validationStatus = false;
    } else if (!firstName?.match(nameRegex)) {
      errors.firstName =
        <Translate textKey={'name_validation_message'} />
      validationStatus = false;
    }

    if (!lastName) {
      errors.lastName = <Translate textKey={'last_name_required'} />
      validationStatus = false;
    } else if (!lastName?.match(nameRegex)) {
      errors.lastName =
        <Translate textKey={'name_validation_message'} />
      validationStatus = false;
    }

    if (!country) {
      errors.country = <Translate textKey={'country_required'} />
      validationStatus = false;
    } else if (country === <Translate textKey={'select_country'} />) {
      errors.country = <Translate textKey={'country_required'} />
      validationStatus = false;
    }
    try {
      if (phone && phone.trim() !== "") {

        // Ensure only a single '+' prefix
        const formattedPhone = '+' + phone.replace(/^(\++)/, '');
        const phoneNumber = parsePhoneNumber(formattedPhone);

        if (!phoneNumber.isValid()) {
          errors.phone = <Translate textKey={'phone_error_msg'} />;
          validationStatus = false;
        }
        setChangedValue({
          ...changedValue,
          phone: phoneNumber.formatInternational(),
        });
      }
    } catch (e) {
      errors.phone = <Translate textKey={'phone_error_msg'} />;
      validationStatus = false;
    }
    setErrors(errors);
    return validationStatus;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (validation() === true) {
      //  setValues((prev) => ({ ...prev, currentPassword: "" }));
      // setPasswordModal(true);
      setValues((prev) => ({ ...prev }));
      updateAccountDetails();
    } else {
      toast.error(<Translate textKey={'check_the_fields'} />, {
        position: "bottom-center",
      });
    }
  };
  const updateAccountDetails = async () => {
    try {
      console.log('changedValues', changedValue);

      const response = await service.updateAccountdetails(appInfo, changedValue);
      if (response?.data?.success === true) {
        toast.success(<Translate textKey={'account_updated_message'} />, {
          position: "bottom-center",
        });
        // setPasswordModal(false);
        fetchAccountDetails(true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  };

  const handleFileChange = (e) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    if (!allowedExtensions.exec(e?.target?.files[0]?.name)) {
      alert(<Translate textKey={'invalid_extension_message'} />)
    } else {

      const name = e?.target?.files[0]?.name;
      const files = e?.target?.files;
      setValues({
        ...values,
        file: files[0],
      });
      setChangedValue({
        ...changedValue,
        file: files[0]
      });
      setProfileWill(URL.createObjectURL(files[0]))
    }
  }

  if (loading) {
    return (
      <Loading />
    )
  }
  return (
    <div className={`accountSettings ${isRTL ? "rtl" : ""}`}>
      {/* {PasswordModal && (
        <CurrentPasswordModal
          fetchAccountDetails={fetchAccountDetails}
          updateAccountDetails={updateAccountDetails}
          values={values}
          handleUpdate={handleUpdate}
          handleUpdateItem={handleUpdateItem}
          handleChange={handleChange}
          setValues={setValues}
          setChangedValue={setChangedValue}
          setErrors={setErrors}
          errors={errors}
          setPasswordModal={setPasswordModal}
        />
      )} */}
      {cancelSubModal && (
        <CancelSubscriptionModal
          fetchAccountDetails={fetchAccountDetails}
          setCancelSubModal={setCancelSubModal}
          subId={accountDetails?.sub_id}
          userSubscriptionId={accountDetails?.user_subscription_id}
          pauseStatus={accountDetails?.pause_status}
          setPauseSubModal={setPauseSubModal}
        />
      )}
      {pauseSubModal && (
        <PauseSubscriptionModal
          fetchAccountDetails={fetchAccountDetails}
          setPauseSubModal={setPauseSubModal}
          subId={accountDetails?.sub_id}
          userSubscriptionId={accountDetails?.user_subscription_id}
        />
      )}
      {logoutModal && (
        <LogoutAllModal
          appInfo={appInfo}
          setLogoutModal={setLogoutModal}
          modalType={{
            type: "logoutAll",
            heading: <Translate textKey={'logout_all_text'} />,
          }}
        />
      )}

      <div className="wrapper">
        <div className="head">
          <h1 className="heading"><Translate textKey={'account_settings'} /></h1>
        </div>

        <div className="contents">
          <div className="left">
            <div className="profileImageContainer">
              {
                profileWill ? (
                  <img src={profileWill} alt="Profile" />

                ) : accountDetails?.user_image ? (
                  <img src={accountDetails?.user_image} alt="Profile" />

                ) : (
                  <img src={require("../../../assets/Images/user_avatar.png")} alt="Avatar" />
                )
              }
              <input type="file" id='file' accept="image/*" onChange={(e) => handleFileChange(e)} />

              <label htmlFor="file"><Translate textKey={'change_picture'} /></label>
            </div>

          </div>

          <div className="right">
            <div className="formSection">
              <form className={`${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : (projectInfo?.projectConfig?.pubid === 50167) ? 'template-12-font' : ''} ${template === 'TEMPLATE_12' ? 'kids' : ''}`}>
                <div className="half">
                  <div className="fname">
                    <label htmlFor="#fname"><Translate textKey={'first_name'} /></label>
                    <input
                      name="firstName"
                      value={values?.firstName || ""}
                      type="text"
                      id="fname"
                      onChange={(item) => handleUpdate(item)}
                    />
                    {errors?.firstName && (
                      <span className="error text-danger">
                        {errors?.firstName}
                      </span>
                    )}
                  </div>
                  <div className="lname">
                    <label htmlFor="#lname"><Translate textKey={'last_name'} /></label>
                    <input
                      name="lastName"
                      type="text"
                      id="lname"
                      value={values?.lastName || ""}
                      onChange={(item) => handleUpdate(item)}
                    />
                    {errors?.lastName && (
                      <span className="error text-danger">
                        {errors?.lastName}
                      </span>
                    )}
                  </div>

                </div>
                <div className="half">
                  <div className="email">
                    <label htmlFor="email"><Translate textKey={'email'} /></label>
                    <input
                      name="email"
                      value={values?.email || ""}
                      disabled
                      type="email"
                      id="email"
                      onChange={(item) => handleUpdate(item)}
                    />
                  </div>


                  <div className="phone fifty">
                    <label htmlFor="phone"><Translate textKey={'phone'} /></label>
                    <PhoneInput
                      enableSearch={true}
                      dropdownStyle={{
                        height: '200px',
                        textAlign: 'justify',
                      }}
                      className="phoneInput"
                      country={'us'} // or set dynamically based on user/country
                      value={values?.phone || ""}
                      onChange={phone => handleChange('phone', phone)}
                      inputProps={{
                        name: 'phone',
                        id: 'phone',
                        required: true,
                      }}
                      inputStyle={{
                        width: '100%',
                        padding: '0% 7%',
                        height: '60px',
                      }}
                      containerClass="phone-input-responsive"
                      name="phone"
                      type="tel"
                    />
                    {
                      errors?.phone &&
                      <span className="error">{errors?.phone}</span>
                    }
                  </div>
                </div>
                {appInfo?.projectDetails?.projectConfig?.pubid === 50124 ? <>
                  <div className="half">
                    <div className="klaviyo fifty">
                      <label htmlFor="email">Shipping Address Line 1</label>
                      <input
                        type="text"
                        name="address1"
                        value={values?.address1 || ""}
                        id="address1"
                        onChange={handleUpdate}
                      />
                    </div>
                    <div className="klaviyo fifty">
                      <label htmlFor="email">Shipping Address Line 2</label>
                      <input
                        type="text"
                        name="address2"
                        value={values?.address2 || ""}
                        id="address2"
                        onChange={handleUpdate}
                      />
                    </div>
                  </div>
                  <div className="half">
                    <div className="fifty">
                      <label htmlFor="#fname">City</label>
                      <input
                        name="city"
                        value={values?.city || ""}
                        type="text"
                        id="city"
                        onChange={(item) => handleUpdate(item)}
                      />

                    </div>
                    <div className="fifty">
                      <label htmlFor="#lname">State</label>
                      <input
                        name="state"
                        type="text"
                        id="state"
                        value={values?.state || ""}
                        onChange={(item) => handleUpdate(item)}
                      />
                    </div>

                  </div>
                  <div className="half">
                    <div className="country">
                      <label htmlFor="text"><Translate textKey={'country'} /></label>
                      <select
                        name="country"
                        id="country"
                        onChange={(item) => handleUpdate(item)}
                      >
                        <option value={currentCountry?.value} >{currentCountry?.name}</option>
                        {countryListOption}
                      </select>
                      {errors?.country && (
                        <span className="error text-danger">
                          {errors?.country}
                        </span>
                      )}
                    </div>
                    <div className="fifty">
                      <label htmlFor="#lname">Postal Code</label>
                      <input
                        name="postal_code"
                        type="text"
                        id="postal_code"
                        value={values?.postal_code || ""}
                        onChange={(item) => handleUpdate(item)}
                      />
                    </div>
                  </div>
                  <div className="half">
                    <div className="fifty">
                      <label htmlFor="#lname">Which Celebrity Did You Sign Up For?</label>
                      <input
                        name="celebrity_source"
                        type="text"
                        id="celebrity_source"
                        value={values?.celebrity_source || ""}
                        onChange={(item) => handleUpdate(item)}
                      />
                    </div>
                    <div className="fifty">
                      <label htmlFor="#lname">Favorite Celebrity Ever?</label>
                      <input
                        name="favorite_celebrity"
                        type="text"
                        id="favorite_celebrity"
                        value={values?.favorite_celebrity || ""}
                        onChange={(item) => handleUpdate(item)}
                      />
                    </div>
                  </div>
                  <div className="half">
                    <div className="fifty">
                      <label htmlFor="#lname">Birthday</label>
                      <input
                        name="birthday"
                        type="date"
                        id="birthday"
                        value={values?.birthday || ""}
                        onChange={(item) => handleUpdate(item)}
                      />
                    </div>
                    <div className="fifty">
                      <label htmlFor="instagram">Instagram Handle</label>
                      <input
                        name="instagram"
                        type="text"
                        id="instagram"
                        value={values?.instagram || ""}
                        onChange={handleUpdate}
                        placeholder="@yourinstagramhandle"
                      />
                    </div>

                  </div>
                  <div className="half">
                    <div className="fifty">
                      <label htmlFor="youtube">YouTube Handle</label>
                      <input
                        name="youtube"
                        type="text"
                        id="youtube"
                        value={values?.youtube || ""}
                        onChange={handleUpdate}
                        placeholder="@youryoutubehandle"
                      />
                    </div>
                    <div className="fifty">
                      <label htmlFor="facebook">Facebook Handle</label>
                      <input
                        name="facebook"
                        type="text"
                        id="facebook"
                        value={values?.facebook || ""}
                        onChange={handleUpdate}
                        placeholder="@yourfacebookhandle"
                      />
                    </div>

                  </div>
                  <div className="half">
                    <div className="fifty">
                      <label htmlFor="tiktok">TikTok Handle</label>
                      <input
                        name="tiktok"
                        type="text"
                        id="tiktok"
                        value={values?.tiktok || ""}
                        onChange={handleUpdate}
                        placeholder="@yourtiktokhandle"
                      />
                    </div>
                  </div>
                </> : <div className="half">
                  <div className="country">
                    <label htmlFor="text"><Translate textKey={'country'} /></label>
                    <select
                      name="country"
                      id="country"
                      onChange={(item) => handleUpdate(item)}
                    >
                      <option value={currentCountry?.value} >{currentCountry?.name}</option>
                      {countryListOption}
                    </select>
                    {errors?.country && (
                      <span className="error text-danger">
                        {errors?.country}
                      </span>
                    )}
                  </div></div>}
                <div className="full">
                  {accountDetails?.password_exists === true ? (
                    <Link to="/change-password">
                      <span className="cpassword"><Translate textKey={'change_password'} /></span>
                    </Link>
                  ) : (
                    <Link to="/set-password" state={accountDetails}>
                      <span className="cpassword"><Translate textKey={'set_password'} /></span>
                    </Link>
                  )}
                </div>
                {appInfo?.projectDetails?.projectConfig?.pubid === 50124 && <div className="disclaimer-section">
                  <label>
                    <input
                      type="checkbox"
                      checked={disclaimerAccepted}
                      onChange={e => {
                        setDisclaimerAccepted(e.target.checked);
                        setChangedValue({
                          ...changedValue,
                          phone: values?.phone ? values.phone.split('+').join('') : '',
                          email_sms_consent: e.target.checked ? true : false,
                          email: values?.email || '',
                        });
                      }}
                    />
                    <span>
                      I acknowledge that by selecting this option, I am consenting to receive promotional communications via Email and SMS. I understand that I may opt out at any time.
                    </span>
                  </label>
                </div>}

                <div
                  className="buttonContainer"
                  onClick={(e) => onSubmitHandler(e)}
                >
                  <div className="background"></div>
                  <button type="submit" className={`bg-button ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                    <Translate textKey={'save_changes'} />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {(accountDetails?.mode_of_payment === "Vizio" || accountDetails?.mode_of_payment === "vizio") && (
          <div className="planDetails">
            <div className="vizio">
              <Translate textKey={'vizio_subscription_message'} /><span onClick={() => window.open('https://www.vizio.com/en/vizio-account', '_blank')}>https://www.vizio.com/en/vizio-account</span>.
            </div>
          </div>
        )}
        {accountDetails?.sub_id && accountDetails?.mode_of_payment !== "Vizio" && accountDetails?.mode_of_payment !== "vizio" && (
          <div className="planDetails">
            <div className="leftContainer">
              <h4 className="heading"><Translate textKey={'plan_details_caps'} /></h4>
            </div>
            <div className="rightContainer">
              <div className="left">
                {accountDetails?.cancel_status === false && accountDetails?.mode_of_payment !== 'giftcard' ? (
                  <>
                    <h2 className="planName">
                      {accountDetails?.subscription_name}
                    </h2>
                    {accountDetails?.subscription_type === 3 || accountDetails?.subscription_type === 4 ?
                      (<div style={{ display: "flex", gap: "10px" }}><div
                        className="buttonContainer"
                        onClick={() => setCancelSubModal(true)}
                      >
                        <div className="background"></div>

                        <button><Translate textKey={'cancel_membership'} /></button>
                      </div>
                        {[50148, 50124].includes(appInfo?.projectDetails?.projectConfig?.pubid) && <>
                          {accountDetails?.pause_status === false ? <div
                            className="buttonContainer"
                            onClick={() => setPauseSubModal(true)}
                          >
                            <div className="background" style={{ background: "#3136af8a" }}></div>

                            <button><Translate textKey={'pause_subscription'} /></button>
                          </div> : <div
                            className="buttonContainer"
                            onClick={() => handleResume()}
                          >
                            <div className="background" style={{ background: "#3136af8a" }}></div>

                            <button><Translate textKey={'resume_subscription'} /></button>
                          </div>}
                        </>}
                      </div>) : null
                    }
                  </>
                ) : accountDetails?.mode_of_payment !== 'giftcard' && (
                  <p><Translate textKey={'subscription_cancelled'} /></p>
                )}
              </div>

              <div className="right">
                <Link to="billing-activity">
                  <span><Translate textKey={'billing_details_title'} /></span>
                </Link>
                {/* {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" && 
                  <Link to="gift-activity">
                    <span><Translate textKey={'gift_details'} /></span>
                  </Link>
                } */}
                {accountDetails?.cancel_status === true ? (
                  <Link to="/subscription">
                    <span><Translate textKey={'subscribe'} /></span>
                  </Link>
                ) : projectInfo?.projectConfig?.config?.CHANGE_PLAN_REQUIRED == "true" && accountDetails?.change_plan_required === true && (accountDetails?.subscription_type === 3 || accountDetails?.subscription_type === 4) &&
                <>
                  {projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? <Link
                    to="/checkout"
                    state={{ type: "upgrade", subId: accountDetails?.sub_id }}
                  >
                    <span><Translate textKey={'change_plan_caps'} /></span>
                  </Link> :
                    <Link
                      to="/subscription"
                      state={{ type: "upgrade", subId: accountDetails?.sub_id }}
                    >
                      <span><Translate textKey={'change_plan_caps'} /></span>
                    </Link>}
                </>
                }
              </div>
            </div>
          </div>
        )}

        {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" && !(accountDetails?.sub_id && accountDetails?.mode_of_payment !== "Vizio" && accountDetails?.mode_of_payment !== "vizio") && (
          <div className="planDetails">
            <div className="leftContainer">
              <h4 className="heading"><Translate textKey={'gift_details_caps'} /></h4>
            </div>
            <div className="rightContainer">
              <div className="left"></div>
              <div className="right">
                <Link to="gift-activity">
                  <span><Translate textKey={'gift_details'} /></span>
                </Link>
              </div>
            </div>
          </div>
        )}
        <div className="settings">
          <div className="leftContainer">
            <h4 className="heading"><Translate textKey={'settings_caps'} /></h4>
          </div>
          <div className="rightContainer">
            <ul>
              <Link to="streaming-activity">
                <li>
                  <span><Translate textKey={'recent_device_streaming_activity'} /></span>
                </li>
              </Link>
              <li onClick={() => setLogoutModal(true)}>
                <span><Translate textKey={'sign_out_from_all_devices'} /></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;
